export class Address {
  addressId: number;
  city: string;
  state: string;
  zip: string;
  street: string;
  building: string;

  constructor(
    addressId?: number,
    city?: string,
    state?: string,
    street?: string,
    building?: string,
    zip?: string) {
    this.addressId = addressId || null;
    this.city = city || null;
    this.state = state || null;
    this.zip = zip || null;
    this.street = street || null;
    this.building = building || null;
  }
}
